var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{directives:[{name:"ga",rawName:"v-ga",value:('listenToWord'),expression:"'listenToWord'"}],staticClass:"ipa",on:{"click":function($event){return _vm.speak(_vm.tts, _vm.lang, $event)}}},[_vm._v(_vm._s(_vm.content))])}
var staticRenderFns = []

export { render, staticRenderFns }